var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 91 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M91 45.5C91 70.63 70.629 91 45.5 91S0 70.63 0 45.5 20.371 0 45.5 0 91 20.37 91 45.5Z",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.914 34.278a6.94 6.94 0 0 1 4.94-2.047c1.866 0 3.62.727 4.94 2.047l8.235 8.241 8.236-8.24v-.001a6.938 6.938 0 0 1 4.939-2.047c1.866 0 3.62.727 4.94 2.047 2.723 2.725 2.723 7.16 0 9.885L46.029 62.288 27.914 44.163c-2.723-2.725-2.723-7.16 0-9.885Zm13.431 56.51a45.99 45.99 0 0 0 9.278-.047V70.349L70.47 50.492c6.212-6.215 6.212-16.328 0-22.543a15.819 15.819 0 0 0-11.265-4.67 15.82 15.82 0 0 0-11.264 4.67l-1.91 1.91-1.91-1.91a15.823 15.823 0 0 0-11.266-4.67 15.821 15.821 0 0 0-11.265 4.67c-6.212 6.215-6.212 16.328 0 22.544L41.346 70.26v20.526Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.3f4a349f.svg";
export { ForwardRef as ReactComponent };